export const ProfileData={
    brandName:'MaKK Zone',
    name: 'Manojkumar Kotakonda',
    topSkills:['Generative AI','AI Agents','AI Architecture','System Design','Full Stack Development','AWS'],
    headline:'Generative AI | AI Agents | Full Stack Developer | AWS | Java | Python',
    intro:'I am an AI Architect with a strong software engineering background. I design and build scalable, production-ready AI systems—specializing in generative AI, AI agents, and cloud-native solutions on AWS. I combine full-stack engineering, system design, and applied research to deliver reliable, secure, and impactful AI-driven products and platforms. My aim is to use my abilities to work on exciting projects that advance technology and benefit society.',
    linkedIn:'https://www.linkedin.com/in/makkzone/',
    blogLink:'https://blog.makkzone.com',
    gitHubLink:'https://github.com/makkzone',
    certifications:[{
        logo:'../assets/aws-certified-developer-associate.png',
        name:'AWS Certified Developer – Associate',
        issuedBy:'Amazon Web Services Training and Certification',
        linkToCertification:'https://www.credly.com/badges/aebb6984-0417-4042-9191-273636b1e6f3/public_url'
    }],
    skills:['Generative AI','AI Agents','AI Architecture','System Design','Full Stack Engineering','AWS Cloud Solutions','Software Engineering','Applied Research','Cloud-Native Solutions','Scalable Systems Design']
}